import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Drawer,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemButton,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../theme";

import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";

const MyDrawerComponent = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <Box display="flex">
      {/* Drawer from Material-UI */}
      <Drawer
        variant="permanent"
        open={!isCollapsed}
        sx={{
          width: isCollapsed ? "80px" : "250px",
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: isCollapsed ? "80px" : "250px",
            boxSizing: "border-box",
            backgroundColor: colors.primary[400],
            transition: "width 0.3s ease",
            overflowX: "hidden",
          },
        }}
      >
        {/* Drawer Content */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p="16px"
        >
          {!isCollapsed && (
            <Typography variant="h3" color={colors.grey[100]}>
              Hatyai Hospital
            </Typography>
          )}
          <IconButton
            onClick={() => setIsCollapsed(!isCollapsed)}
            sx={{ color: colors.grey[100], ml: 0.5 }}
          >
            <MenuOutlinedIcon
              sx={{
                color: isCollapsed
                  ? colors.blueAccent[500]
                  : colors.primary[100],
              }}
            />
          </IconButton>
        </Box>
        <Divider />

        {/* User Section */}
        {!isCollapsed && (
          <Box textAlign="center" my="16px">
            <Box display="flex" justifyContent="center" alignItems="center">
              <img
                alt="Profile-user"
                width="100px"
                height="100px"
                src={process.env.PUBLIC_URL + "/hatyailogo.jpg"}
                style={{ cursor: "pointer", borderRadius: "50%" }}
              />
            </Box>
            <Typography
              variant="h5"
              color={colors.grey[100]}
              mt="8px"
              fontWeight="bold"
            >
              Maintenance team
            </Typography>
            <Typography variant="subtitle1" color={colors.greenAccent[500]}>
              Service and Maintenance
            </Typography>
          </Box>
        )}

        {/* Menu Items */}
        <List>
          {/* Dashboard */}
          <ListItem disablePadding>
            <ListItemButton
              sx={{
                minHeight: 48,
                display: "flex",
                justifyContent: isCollapsed ? "" : "initial",
                px: isCollapsed ? 2 : 2,

                "&:hover": isCollapsed
                  ? {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                      borderRadius: "50px",
                    }
                  : {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                    },
              }}
              onClick={() => navigate("/Dashboard")}
            >
              <HomeOutlinedIcon
                sx={{
                  color: colors.grey[100],
                  ml: isCollapsed ? "10px" : "0px",
                }}
              />
              {!isCollapsed && (
                <Typography variant="body1" color={colors.grey[100]} ml="16px">
                  Dashboard
                </Typography>
              )}
            </ListItemButton>
          </ListItem>
          {/* <Typography
            variant="h6"
            sx={{
              m: "15px 0 5px 20px",
              color: isCollapsed ? colors.blueAccent[300] : colors.grey[300],
            }}
          >
            Data
          </Typography> */}
          {/* Manage Team */}
          {/* <ListItem disablePadding>
            <ListItemButton
              sx={{
                minHeight: 48,
                display: "flex",
                justifyContent: isCollapsed ? "" : "initial",
                px: isCollapsed ? 2 : 2,

                "&:hover": isCollapsed
                  ? {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                      borderRadius: "50px",
                    }
                  : {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                    },
              }}
              onClick={() => navigate("/Team")}
            >
              <PeopleOutlinedIcon
                sx={{
                  color: colors.grey[100],
                  ml: isCollapsed ? "10px" : "0px",
                }}
              />
              {!isCollapsed && (
                <Typography variant="body1" color={colors.grey[100]} ml="16px">
                  Manage Team
                </Typography>
              )}
            </ListItemButton>
          </ListItem> */}
          {/* Contract information */}
          {/* <ListItem disablePadding>
            <ListItemButton
              sx={{
                minHeight: 48,
                display: "flex",
                justifyContent: isCollapsed ? "" : "initial",
                px: isCollapsed ? 2 : 2,

                "&:hover": isCollapsed
                  ? {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                      borderRadius: "50px",
                    }
                  : {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                    },
              }}
              onClick={() => navigate("/Contract")}
            >
              <ContactsOutlinedIcon
                sx={{
                  color: colors.grey[100],
                  ml: isCollapsed ? "10px" : "0px",
                }}
              />
              {!isCollapsed && (
                <Typography variant="body1" color={colors.grey[100]} ml="16px">
                  Contract information
                </Typography>
              )}
            </ListItemButton>
          </ListItem> */}
          {/* <Typography
            variant="h6"
            sx={{
              m: "15px 0 5px 20px",
              color: isCollapsed ? colors.blueAccent[300] : colors.grey[300],
            }}
          >
            Pages
          </Typography> */}
          {/* Profile Form */}
          {/* <ListItem disablePadding>
            <ListItemButton
              sx={{
                minHeight: 48,
                display: "flex",
                justifyContent: isCollapsed ? "" : "initial",
                px: isCollapsed ? 2 : 2,

                "&:hover": isCollapsed
                  ? {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                      borderRadius: "50px",
                    }
                  : {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                    },
              }}
              onClick={() => navigate("/Profile")}
            >
              <PersonOutlinedIcon
                sx={{
                  color: colors.grey[100],
                  ml: isCollapsed ? "10px" : "0px",
                }}
              />
              {!isCollapsed && (
                <Typography variant="body1" color={colors.grey[100]} ml="16px">
                  Profile Form
                </Typography>
              )}
            </ListItemButton>
          </ListItem> */}
          {/* FAQ Form */}
          {/* <ListItem disablePadding>
            <ListItemButton
              sx={{
                minHeight: 48,
                display: "flex",
                justifyContent: isCollapsed ? "" : "initial",
                px: isCollapsed ? 2 : 2,

                "&:hover": isCollapsed
                  ? {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                      borderRadius: "50px",
                    }
                  : {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                    },
              }}
              onClick={() => navigate("/FAQ")}
            >
              <HelpOutlineOutlinedIcon
                sx={{
                  color: colors.grey[100],
                  ml: isCollapsed ? "10px" : "0px",
                }}
              />
              {!isCollapsed && (
                <Typography variant="body1" color={colors.grey[100]} ml="16px">
                  FAQ
                </Typography>
              )}
            </ListItemButton>
          </ListItem> */}
          {/* <Typography
            variant="h6"
            sx={{
              m: "15px 0 5px 20px",
              color: isCollapsed ? colors.blueAccent[300] : colors.grey[300],
            }}
          >
            Chart
          </Typography> */}
          {/* Calendar  */}
          {/* <ListItem disablePadding>
            <ListItemButton
              sx={{
                minHeight: 48,
                display: "flex",
                justifyContent: isCollapsed ? "" : "initial",
                px: isCollapsed ? 2 : 2,

                "&:hover": isCollapsed
                  ? {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                      borderRadius: "50px",
                    }
                  : {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                    },
              }}
              onClick={() => navigate("/Calendar")}
            >
              <CalendarTodayOutlinedIcon
                sx={{
                  color: colors.grey[100],
                  ml: isCollapsed ? "10px" : "0px",
                }}
              />
              {!isCollapsed && (
                <Typography variant="body1" color={colors.grey[100]} ml="16px">
                  Calendar
                </Typography>
              )}
            </ListItemButton>
          </ListItem> */}
          {/* Bar Chart  */}
          {/* <ListItem disablePadding>
            <ListItemButton
              sx={{
                minHeight: 48,
                display: "flex",
                justifyContent: isCollapsed ? "" : "initial",
                ml: isCollapsed ? "" : "",
                px: isCollapsed ? 2 : 2,

                "&:hover": isCollapsed
                  ? {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                      borderRadius: "50px",
                    }
                  : {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                    },
              }}
              onClick={() => navigate("/Barchart")}
            >
              <BarChartOutlinedIcon
                sx={{
                  color: colors.grey[100],
                  ml: isCollapsed ? "10px" : "0px",
                }}
              />
              {!isCollapsed && (
                <Typography variant="body1" color={colors.grey[100]} ml="16px">
                  Bar Chart
                </Typography>
              )}
            </ListItemButton>
          </ListItem> */}
          {/* Pie Chart  */}
          {/* <ListItem disablePadding>
            <ListItemButton
              sx={{
                minHeight: 48,
                display: "flex",
                justifyContent: isCollapsed ? "" : "initial",
                ml: isCollapsed ? "" : "",
                px: isCollapsed ? 2 : 2,

                "&:hover": isCollapsed
                  ? {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                      borderRadius: "50px",
                    }
                  : {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                    },
              }}
              onClick={() => navigate("/Piechart")}
            >
              <PieChartOutlineOutlinedIcon
                sx={{
                  color: colors.grey[100],
                  ml: isCollapsed ? "10px" : "0px",
                }}
              />
              {!isCollapsed && (
                <Typography variant="body1" color={colors.grey[100]} ml="16px">
                  Pie Chart
                </Typography>
              )}
            </ListItemButton>
          </ListItem> */}
          {/* Line Chart  */}
          {/* <ListItem disablePadding>
            <ListItemButton
              sx={{
                minHeight: 48,
                display: "flex",
                justifyContent: isCollapsed ? "" : "initial",
                ml: isCollapsed ? "" : "",
                px: isCollapsed ? 2 : 2,

                "&:hover": isCollapsed
                  ? {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                      borderRadius: "50px",
                    }
                  : {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                    },
              }}
              onClick={() => navigate("/Linechart")}
            >
              <TimelineOutlinedIcon
                sx={{
                  color: colors.grey[100],
                  ml: isCollapsed ? "10px" : "0px",
                }}
              />
              {!isCollapsed && (
                <Typography variant="body1" color={colors.grey[100]} ml="16px">
                  Line Chart
                </Typography>
              )}
            </ListItemButton>
          </ListItem> */}
          {/* Geography Chart  */}
          {/* <ListItem disablePadding>
            <ListItemButton
              sx={{
                minHeight: 48,
                display: "flex",
                justifyContent: isCollapsed ? "" : "initial",
                ml: isCollapsed ? "" : "",
                px: isCollapsed ? 2 : 2,

                "&:hover": isCollapsed
                  ? {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                      borderRadius: "50px",
                    }
                  : {
                      backgroundColor: colors.primary[300],
                      cursor: "pointer",
                    },
              }}
              onClick={() => navigate("/Geochart")}
            >
              <MapOutlinedIcon
                sx={{
                  color: colors.grey[100],
                  ml: isCollapsed ? "10px" : "0px",
                }}
              />
              {!isCollapsed && (
                <Typography variant="body1" color={colors.grey[100]} ml="16px">
                  Geo Chart
                </Typography>
              )}
            </ListItemButton>
          </ListItem> */}
        </List>
      </Drawer>
    </Box>
  );
};

export default MyDrawerComponent;
